import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M3 18l9 -6.462l-9 -5.538v12h18v-12l-9 5.538","key":"svg-0"}]]

/**
 * IconBrandCampaignmonitor
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItYnJhbmQtY2FtcGFpZ25tb25pdG9yIgo+CiAgPHBhdGggc3Ryb2tlPSJub25lIiBkPSJNMCAwaDI0djI0SDB6IiBmaWxsPSJub25lIiAvPgogIDxwYXRoIGQ9Ik0zIDE4bDkgLTYuNDYybC05IC01LjUzOHYxMmgxOHYtMTJsLTkgNS41MzgiIC8+Cjwvc3ZnPg==) - https://tabler.io/icons/icon/brand-campaignmonitor
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconBrandCampaignmonitor = createReactComponent('outline', 'brand-campaignmonitor', 'BrandCampaignmonitor', __iconNode);

export default IconBrandCampaignmonitor;